<template>
  <div>
    <div class="white small" style="color: rgba(255, 255, 255, 0.8)">
      Anonymization IPs
    </div>
    <div class="jura white bold count mb-3">
      {{ totalCount }}
    </div>
    <div>
      <div class="white small" style="color: rgba(255, 255, 255, 0.47)">
        Change today 
      </div>
      <div class="white small bold">
        <div v-if="deltaWeek > 0" style="color: rgb(105, 248, 147)"><font-awesome-icon  class="icon" :icon="['fas', 'arrow-trend-up']" /> {{ deltaWeek }}</div>
        <div v-else-if="deltaWeek == 0" style="color: rgba(255, 255, 255, 0.47)"><font-awesome-icon  class="icon" :icon="['fas', 'arrow-trend-up']" /> {{ deltaWeek }}</div>
        <div v-else style="color: rgb(248, 105, 105)" ><font-awesome-icon class="icon" :icon="['fas', 'arrow-trend-down']" /> {{ deltaWeek * -1 }}</div>
      </div>
       
    </div>
  </div>
  <div ref="chartRef" class="chart"></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue"
import * as echarts from "echarts"
import Provider from '@/api/Provider.js'

const chartRef = ref(null)
let chartInstance = null
const totalCount = ref(0)
const deltaWeek = ref(0)

onMounted(async () => {
  chartInstance = echarts.init(chartRef.value)

  const data = (await Provider.dailyStats())

  totalCount.value = data[data.length-1].total
  deltaWeek.value = (data[data.length-1].total - data[data.length-2].total)

  try {
    const option = {
      grid: { left: 0, right: 0, top: 20, bottom: 30 },
      tooltip: {
        trigger: "axis",
        formatter: params => {
          const { axisValue, data } = params[0]
          return `${axisValue}<br/>Total: ${data}`
        }
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: data.map(d => new Date(d.day).toISOString().slice(8, 10) + " " +
                             new Date(d.day).toLocaleString("en-US", { month: "short" }).toUpperCase()),
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: true, fontSize: 10, color: "#ffffff40" },
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(255,255,255,0.01)", // faint vertical lines
            width: 1
          }
        }
      },
      yAxis: {
        type: "value",
        show: true, // necessary for horizontal lines
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false }, // hide numbers
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(255,255,255,0.01)", // faint horizontal lines
            width: 1
          }
        }
      },
      series: [
        {
          type: "line",
          smooth: true,
          symbol: "none",
          lineStyle: { color: "#fff", width: 3 },
          data: data.map(d => d.total),
          areaStyle: {
            color: {
              type: "linear",
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(255,255,255,0.1)" },
                { offset: 1, color: "rgba(255,255,255,0)" }
              ]
            }
          }
        }
      ]
    }

    chartInstance.setOption(option)
    window.addEventListener("resize", chartInstance.resize)
  } catch (err) {
    console.error("Failed to fetch stats:", err)
  }
})

onBeforeUnmount(() => {
  if (chartInstance) {
    window.removeEventListener("resize", chartInstance.resize)
    chartInstance.dispose()
  }
})
</script>

<style scoped>
.chart {
  width: 100%;
  height: 400px;
}

.count {
  font-size: 3rem;
  line-height: 3rem;
}
</style>
